<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { employeelist } from '@/api/room'
import { watch } from 'vue';
const props = defineProps<{
    value: any[]
    id: string
}>()

const serverList = ref<any[]>([])
const tempList = ref<any[]>([])
const servers = ref<any>('')
const searchInput = ref<string>('')

const emit = defineEmits(['change'])

onMounted(() => {
    employeelist({
        positionStatus: '1'
    }).then((res) => {
        serverList.value = res.rows.map((i: any) => ({
            id: i.userId,
            name: i.userName
        }))
        tempList.value = serverList.value
    })
})

const search = (e: string) => {
    if (!e.trim()) {
        tempList.value = serverList.value
        return
    }
    tempList.value = tempList.value.filter((i: any) => i.name.includes(e))
}

const change = (e: number) => {
    // console.log(e);
    // const server = e.map((i: number) => {
    //     return 
    // })
    if (!e) {
        emit('change', [], props.id)
        return
    }
    const s = serverList.value.find((j) => j.id == e)
    emit('change', [s], props.id)
}

watch(() => props.value, (newVal) => {
    servers.value = newVal.map((i: any) => i.id)[0]
}, {
    deep: true,
    immediate: true
})
</script>

<template>
    <div class="w-full  bg-white overflow-auto relative">
        <div class="absolute  w-full bg-white z-10">
            <div class="text-[16px] flex justify-between bg-white">
                <div>选择服务人员</div>
                <div @click="() => change(servers)">确定</div>
            </div>
            <div class=" p-3 border-b-[1px]">
                <el-input v-model="searchInput" placeholder="搜索" @input="search"></el-input>
            </div>
        </div>

        <div class="p-2 mt-20 h-[500px] overflow-y-auto">
            <el-radio-group v-model="servers" class="w-full">
                <div class="flex flex-col w-full">
                    <div v-for="i in tempList" class="p-2 border-b-[1px] w-full" :key="i.id">
                        <el-radio :value="i.id" class="w-full">
                            <div>{{ i.name }}</div>
                        </el-radio>
                    </div>
                </div>
            </el-radio-group>
        </div>
    </div>
</template>